import { Layout } from "antd";
import React, { useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import Sidebar from "./_components/Sidebar";
import AppHeader from "./_components/Header";

import Notice from "../pages/Notice";
import Project from "../pages/Projects";
import Album from "../pages/Album";
import AlbumShow from "../pages/Album/AlbumShow";
import Vacancy from "../pages/Vacancy";
import CompanyInfo from "../pages/CompanyInfo";
import Messages from "../pages/Message";
import Employee from "../pages/Employee";
import Home from "../pages/Home";

import { selectUser } from "../store/slices/authSlice";

import "./index.css";
import ProjectShow from "../pages/Projects/ProjectShow";
import Users from "../pages/User";

const { Content, Footer } = Layout;

const PrivateLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  const user = useSelector(selectUser);

  if (!user) {
    return <Redirect to="/login" />;
  }

  return (
    <Layout className="neaec-admin-layout">
      <Sidebar collapsed={collapsed} />
      <Layout
        className="site-layout"
        style={{
          marginLeft: collapsed ? 80 : 250,
          transition: "margin-left 0.21s ease",
        }}
      >
        <AppHeader collapsed={collapsed} setCollapsed={setCollapsed} />
        <Content
          className="site-layout-background"
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: "calc(100vh - 182px)",
          }}
        >
          <Switch>
            <Route component={Home} path="/home" />
            <Route component={Notice} path="/notices" />
            <Route component={ProjectShow} path="/projects/:id" />
            <Route component={Project} path="/projects" />
            <Route component={CompanyInfo} path="/company" />
            <Route component={AlbumShow} path="/gallery/:id" />
            <Route component={Album} path="/gallery" />
            <Route component={Vacancy} path="/vacancies" />
            <Route component={Messages} path="/messages" />
            <Route component={Employee} path="/employees" />
            <Route component={Users} path="/users" />
          </Switch>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          NEA Engineering Company ©{new Date().getFullYear()} Developed by Map
          Nepal
        </Footer>
      </Layout>
    </Layout>
  );
};

export default PrivateLayout;
